function forceKeyPressLowercase(e) {
  const charInput = e.keyCode;
  if (charInput >= 65 && charInput <= 90) {
    // lowercase
    if (!e.ctrlKey && !e.metaKey && !e.altKey) {
      // no modifier key
      const newChar = charInput + 32;
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;
      e.target.value =
        e.target.value.substring(0, start) +
        String.fromCharCode(newChar) +
        e.target.value.substring(end);
      e.target.setSelectionRange(start + 1, start + 1);
      e.preventDefault();
    }
  }
}

export function useForceLowerCase() {
  return {
    forceKeyPressLowercase,
  };
}
